import { CURRENCY } from 'src/types';

export enum PAYMENT_TYPE {
    CASH = 'cash',
    // CARD = 'card',
    BANK = 'bank',
    // ONLINE = 'online',
}

export enum PAYMENT_TYPE_FOR_TABLE_BADGE {
    CASH = 'cash',
    CARD = 'card',
    BANK = 'bank',
}

export enum PAYMENT_STATUS {
    PAID = 'paid',
    CANCELLED = 'cancelled',
    FAILED = 'failed',
    REFUNDED = 'refunded',
    ROLLBACK = 'rollbacked',
}

export type Payment = {
    id: string;
    tenant: {
        id: string;
        name: string;
    };
    // A payment is linked to documents through PaymentAllocation, so it can settle more than one.
    financial_documents: {
        id: string;
        type: string;
        number: string;
        currency: CURRENCY;
        issue_due_date: string | null;
    }[];
    customer: {
        id: string;
        name: string;
    };
    created_at: string;
    modified_at: string;
    date: string;
    currency: CURRENCY;
    amount: number;
    allocated_amount: number;
    remaining_amount: number;
    type: PAYMENT_TYPE;
    reference: string | null;
    money_account: {
        id: string;
        name: string;
    };
    payment_payload_details: unknown;
    status: PAYMENT_STATUS;
    refunded_amount: number | null;
};
